import { LancementsTab } from "@features/production/components/LancementsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Rocket } from "lucide-react";

export const Route = createFileRoute("/_app/production/lancements/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.LANCEMENTS.VIEW),
  staticData: {
    title: "Lancements",
    icon: Rocket,
    tab_icon: Rocket,
    permission: PERMISSIONS.PRODUCTION.LANCEMENTS.VIEW,
    section: "App",
    module: "production",
    order: 40,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Lancements en production",
  },
  component: LancementsTab,
});
